import React from 'react';
import { ContactsContainer } from './ui';

export const ContactsScreen: React.FC = () => <ContactsContainer />;
